import imgCover from "../assets/projects/1.jpg"; 
import imgCover2 from "../assets/projects/5.jpg"; 

export const projects = [
  {
    id: 1,
    title: "Различията като източник на познание",
    short: "Проект, насочен към развитие на местната общност, културни инициативи и гражданско участие.",
    image: imgCover,
    slug: "razlichiqta-kato-iztochnik-na-poznanie",
    year: "2023 – 2024",
  },

  {
    id: 2,
    title: "Проект Еразъм 2024-1-BG01-K1-YOU-000286552",
    short: "Тема изкуственият интелект има ли бъдеще изпълняван от Сдружение „ НЕВРОКОП“ ",
    image: imgCover2,
    slug: "nov-proekt-primer",
    year: "2024 – 2025",
  },
];
